import React from "react";
import { string } from "prop-types";

const Instagram = ({ color = "#eee" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19.511" height="19.508">
    <g id="Group_585" data-name="Group 585" transform="translate(-25 -20)">
      <path
        id="Path_16"
        d="M38.694 20H30.81A5.816 5.816 0 0025 25.81v7.885a5.82 5.82 0 005.813 5.813H38.7a5.82 5.82 0 005.813-5.813V25.81A5.822 5.822 0 0038.694 20zm3.852 13.694a3.85 3.85 0 01-3.846 3.849h-7.89a3.85 3.85 0 01-3.848-3.848V25.81a3.85 3.85 0 013.848-3.848h7.885a3.85 3.85 0 013.848 3.848v7.885z"
        fill={color}
        data-name="Path 16"
      />
      <path
        id="Path_17"
        d="M163.045 153a5.045 5.045 0 105.045 5.045 5.05 5.05 0 00-5.045-5.045zm0 8.129a3.084 3.084 0 113.084-3.084 3.084 3.084 0 01-3.084 3.084z"
        fill={color}
        data-name="Path 17"
        transform="translate(-128.291 -128.291)"
      />
      <circle
        id="Ellipse_20"
        cx="1.207"
        cy="1.207"
        r="1.207"
        fill={color}
        data-name="Ellipse 20"
        transform="translate(38.602 23.537)"
      />
    </g>
  </svg>
);

Instagram.propTypes = {
  color: string
};

export default Instagram;
